import React, { useState } from 'react';

import CreditsCost from '@repo/editor/src/components/CreditsCost/CreditsCost';
import {
  ActionsWithCost,
  creditsCostUtil,
} from '@repo/editor/src/utils/credits';
import { withEventScope } from '@repo/event-processor';
import SceneIcon from '@repo/ui/components/Icon/SceneIcon';
import StarPairIcon from '@repo/ui/components/Icon/StarPairIcon';
import { themeStyle } from '@repo/ui/theming';

import RightPanel from 'components/AiTools/RigthPanel/RightPanel';
import { TabDetails } from 'components/AiTools/RigthPanel/types';
import { LayoutSwitch } from 'styles/queries';

import Presets from './Presets';
import Prompt from './Prompt';
import { Tab, SceneProps } from './types';

const tabs: TabDetails<Tab>[] = [
  {
    id: 'presets',
    width: '86px',
    icon: SceneIcon,
    label: 'Scene',
  },
  {
    id: 'prompt',
    width: '100px',
    icon: StarPairIcon,
    label: 'Prompt',
  },
];

const Scene: React.FC<SceneProps> = ({
  isLoading,
  disabled,
  buttonLabel,
  presets,
  onGenerateClick,
}) => {
  const [activeTab, setActiveTab] = useState<Tab>('presets');

  const [activePresetId, setActivePresetId] = useState<string | null>(null);

  const [includePrompt, setIncludePrompt] = useState('');
  const [excludePrompt, setExcludePrompt] = useState('');

  const isGenerationDisabled =
    isLoading ||
    (activeTab === 'presets' && !activePresetId) ||
    (activeTab === 'prompt' && !includePrompt.length);

  const handleGenerateClick = (): void => {
    const options =
      activeTab === 'presets'
        ? {
            presetId: activePresetId!,
          }
        : { includePrompt, excludePrompt };

    onGenerateClick(options);
  };

  const isDisabled = isGenerationDisabled || disabled;

  const creditCost = (
    <CreditsCost
      color={isDisabled ? themeStyle.varInkMedium : themeStyle.varInkBase}
      cost={creditsCostUtil[ActionsWithCost.BackgroundReplacer]}
    />
  );
  const showCreditCost = buttonLabel === 'Generate Background';

  return (
    <LayoutSwitch
      mobileBreakpoint="tabletAndUp"
      mobileProps={{ smallFooter: true }}
    >
      <RightPanel
        activeTab={activeTab}
        buttonIcon={showCreditCost ? creditCost : undefined}
        buttonLabel={buttonLabel}
        disabled={isDisabled}
        isLoading={isLoading}
        setActiveTab={setActiveTab}
        tabs={tabs}
        onClick={handleGenerateClick}
      >
        {activeTab === 'presets' && (
          <Presets
            activePresetId={activePresetId}
            presets={presets}
            onPresetClick={setActivePresetId}
          />
        )}
        {activeTab === 'prompt' && (
          <Prompt
            initialExcludePrompt={excludePrompt}
            initialIncludePrompt={includePrompt}
            onExcludePromptChange={setExcludePrompt}
            onIncludePromptChange={setIncludePrompt}
          />
        )}
      </RightPanel>
    </LayoutSwitch>
  );
};

export default withEventScope(Scene, { feature: 'scene' });
